import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReferralsService} from '../services/referrals.service';
import {MatTableGeneratorComponent} from '../../shared/mat-table-generator/mat-table-generator.component';
import {ReferralStatus} from '../../dto/ident-status';
import {FormControl} from '@angular/forms';
import {CompanyService} from '../services/company.service';
import {Company} from '../../dto/company';
import {RoleService} from '../../services/role.service';
import {MultiCrudDataSource} from '../../table-datasouces/multi-crud.datasource';
import {Referral} from '../../dto/order';
import {toDateString} from '../../providers/app-date-adapter';
import {ContentRowField} from '../../shared/content-row/content-row.component';
import {MatButtonToggle} from '@angular/material/button-toggle';

@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.css']
})
export class ReferralsComponent implements OnDestroy, AfterViewInit, OnInit {
  isLoading = false;
  companies: Company[] = [];

  public dateFiltersList = [
    { name: 'creation', header: 'Creation' },
    { name: 'payment', header: 'Bonus payment' },
  ];
  public referralsPendingBonusCountValue: number|null = null;

  constructor(
    private referralsService: ReferralsService,
    private companyService: CompanyService,
    private roleService: RoleService,
  ) { }

  public referralStatus = ReferralStatus;
  public referralSpecialStatusSelect = new FormControl();
  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;
  @ViewChild(MatButtonToggle, { static: false }) allButton: MatButtonToggle;

  dataSource = new MultiCrudDataSource(this.referralsService);

  columns = [
    { columnDef: 'creationDate', header: 'Creation date', cell: row => `${toDateString(row.referralCreated) || ''}` } as ContentRowField<Referral>,
    { columnDef: 'customer', header: 'Referrer', cell: row => `${row.customer.firstName} ${row.customer.lastName}` } as ContentRowField<Referral>,
    { columnDef: 'phoneNumber', header: 'Referee Phone', cell: row => `${row.phoneNumber}` } as ContentRowField<Referral>,
    { columnDef: 'refereeCustomer', header: 'Referree', cell: row => `${row.firstname || ''} ${row.lastname || ''}` } as ContentRowField<Referral>,
    { columnDef: 'identified', icon: row => {
        if ( !row.identified ) {
return null;
}
        return 'check';
}, header: 'Identified', cell: row => '' } as ContentRowField<Referral>,
    { columnDef: 'numberOfLoads', header: '# Loads', cell: row => `${row.numberOfLoads}/${row.numberOfLoads}` } as ContentRowField<Referral>,
    { columnDef: 'numberOfTransactions', header: '# TXNs', cell: row => `${row.numberOfTransactions}/${row.targetNumberOfTransactions}` } as ContentRowField<Referral>,
    { columnDef: 'status', header: 'Status', icon: row => {
        if ( row.status == ReferralStatus.pendingBonus ) {
return 'assignment';
}
        return null;
      }, iconColor: row => {
        if ( row.status == ReferralStatus.pendingBonus ) {
return 'blue';
}

        return null;
      }, cellColor: row => {
        if ( row.status == ReferralStatus.pendingBonus ) {
return 'blue';
}
        if ( row.status == ReferralStatus.completed ) {
return 'green';
}
        return null;
      }, cell: row => {
      if ( row.status == ReferralStatus.accpeted ) {
return 'Accepted';
}
      if ( row.status == ReferralStatus.ordered ) {
return 'Ordered';
}
      if ( row.status == ReferralStatus.pendingBonus ) {
return 'Pending bonus';
}
      if ( row.status == ReferralStatus.completed ) {
return 'Completed';
}
      if ( row.status == ReferralStatus.expired ) {
return 'Expired';
}

      return row.status;
      }
    } as ContentRowField<Referral>,
    { columnDef: 'possibleCommission', header: 'Possible Commission', cell: row => `${row.possibleCommission} / ${row.possibleRefereeCommission || '-'}` } as ContentRowField<Referral>,


  ];

  checkAllButton() {
    try {
      this.allButton.checked = true;


    } catch (e) {
 console.log(e);
}
  }

  getViewLink = (item: Referral): string => item.id.toString();

  getEditLink = (item: Referral): string => item.status >= ReferralStatus.completed ? null : item.id.toString() + '/edit';
  public dialogRemoveText = 'Removing referrals';


  ngOnInit(): void {
    this.referralsService.getPendingCount().subscribe(i => {
      this.referralsPendingBonusCountValue = i;
    });
  }

  clearFilter() {
    this.referralSpecialStatusSelect.patchValue(null);

    // this.multiButton.buttonToggleGroup.value = "";

    this.table.clearFilter();
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  editEnabled() {
    return false; // this.roleService.hasRoles("admin");
  }

  deleteEnabled() {
    return false; // this.roleService.hasRoles("admin");
  }

  multiselectEnabled() {
    return this.roleService.hasRoles(['admin', 'manager', 'agent', 'partner']);
  }

  currentUserIsAdmin(){
    return this.roleService.hasRoles('admin');
  }

  onReferralStatusChange() {
    this.table.filters.enumFilter = { key: 'ReferralSpecialStatus', value: this.referralSpecialStatusSelect.value };
    this.triggerSearch();
  }
  triggerSearch() {
    this.onSearch();
  }
  onSearch(ignore: boolean = false) {
    if ( this.isLoading ) {
return;
}
    if (ignore) {
return;
}
    this.table.applyFilter();
  }
  ngAfterViewInit(): void {

    this.companyService.getAll().subscribe(result => {
      this.companies = result.data;
    });
    if (this.currentUserIsAdmin()) {

    }

  }

  ngOnDestroy(): void {
  }

}
